import React, { memo, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import Modal from 'react-modal';
import { TOGGLE_ADD_SERVICE_POPUP_VISIBILITY } from '../../actions/types';
import axios from '../../utils/axios';
import { useRouter } from 'next/router';
import { AddService, CatOp, SNAMe } from 'helpers/dictionary';

const PopupCss = styled.div`
  width: 90%;
  margin: auto;
  background: white;
  box-shadow: 0px 63px 50px rgba(67, 67, 68, 0.0705882);
  padding: 2.4rem;
  border-radius: 0.4rem;
  h4 {
    font-size: 1.4rem;
    margin: 0;
    margin-bottom: 1rem;
  }
  select,
  input {
    margin-bottom: 1.4rem;
    font-size: 1.2rem;
    padding: 0.8rem;
    width: 100%;
    border: 2px solid #e2e2e9;
  }
  button {
    cursor: pointer;
    background: var(--color-flickr-blue);
    box-shadow: 0px 3px 6px rgba(54, 98, 216, 0.3);
    border-radius: 4px;
    font-weight: 600;
    font-size: 1.4rem;
    color: #ffffff;
    border: 0;
    padding: 1.2rem 2.4rem;
  }
  @media (min-width: 768px) {
    width: 40rem;
  }
`;

const AddServicePopup = () => {
    const visibility = useSelector((state) => state.popups.addServicePopup);
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.settings.lang);

    const [service, setService] = useState({
        categoryId: null,
        serviceName: '',
    });

    const [categories, setCategories] = useState([]);

    const router = useRouter();

    useEffect(() => {
        const fetchCategories = async () => {
            const { data } = await axios.get('/api/v1/category');
            if (data.categories) {
                setCategories(data.categories);
            }
        };

        if (visibility) {
            fetchCategories();
        }
    }, [visibility]);

    const handleSubmit = async () => {
        dispatch({
            type: TOGGLE_ADD_SERVICE_POPUP_VISIBILITY,
            payload: false,
        });

        return router.replace(
            `/request-service?serviceName=${service.serviceName}&categoryId=${service.categoryId}`
        );
    };

    if (visibility) {
        return (
            <>
                <Modal
                    appElement={document.getElementById('__next')}
                    isOpen={true}
                    contentLabel="Add Service Modal"
                    onRequestClose={() => {
                        dispatch({
                            type: TOGGLE_ADD_SERVICE_POPUP_VISIBILITY,
                            payload: false,
                        });
                    }}
                    className="modal"
                >
                    <PopupCss>
                        <h1>{AddService[lang]}</h1>
                        <form onSubmit={handleSubmit}>
                            <div className="choose-category">
                                <h4>{CatOp[lang]}</h4>
                                <select
                                    onChange={(e) =>
                                        setService({
                                            ...service,
                                            categoryId: parseInt(e.target.value),
                                        })
                                    }
                                >
                                    <option value="">Choose a category</option>
                                    {categories.map((category) => (
                                        <option key={category.id} value={category.id}>
                                            {category.titleEN}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div>
                                <h4>{SNAMe[lang]}</h4>
                                <input
                                    type="text"
                                    placeholder="Service Name"
                                    onChange={(e) =>
                                        setService({
                                            ...service,
                                            serviceName: e.target.value,
                                        })
                                    }
                                    value={service.serviceName}
                                    required
                                />
                            </div>
                            <button>Add Service</button>
                        </form>
                    </PopupCss>
                </Modal>
            </>
        );
    } else {
        return null;
    }
};

export default memo(AddServicePopup);
